
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","fill-opacity":".01","fill-rule":"evenodd","d":"M0 0h48v48H0z"}}),_c('g',{attrs:{"transform":"translate(4 4)","fill":"none","stroke-linejoin":"round","stroke-width":"4","stroke":"#7f8398"}},[_c('path',{attrs:{"d":"M0 29h40v10H0z"}}),_c('path',{attrs:{"stroke-linecap":"round","d":"M22 22h12v7H22z"}}),_c('circle',{attrs:{"cx":"14","cy":"5","r":"5"}}),_c('path',{attrs:{"d":"M12 10L5 29","stroke-linecap":"round"}})])])
          )
        }
      }
    